export const EMPTY_VALUE_LABEL = '--';
